import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import { InventaireForm } from '@features/stock/components/InventaireForm'
import { useCreateInventaire } from '@features/stock/hooks/useInventaireMutations'
import type { Inventaire } from '@features/stock/types'

export const Route = createFileRoute('/_app/stock/inventaires/create')({
  loader: requirePermission('stock.inventaires.create'),
  component: CreateInventaire,
})

function CreateInventaire() {
  const navigate = useNavigate()
  const createMutation = useCreateInventaire()

  const handleSuccess = () => {
    navigate({ to: '/stock/inventaires' })
  }

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Nouvel inventaire</h1>
      <div className="bg-base-100 rounded-lg shadow p-6">
        <InventaireForm
          mode="create"
          onSuccess={handleSuccess}
        />
      </div>
    </div>
  )
}
